import { render } from "./ElectionsPortal.vue?vue&type=template&id=a03752b4"
import script from "./ElectionsPortal.vue?vue&type=script&lang=js"
export * from "./ElectionsPortal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__